module.exports = __webpack_public_path__ + "media/images/new_library-c15de21739b495626b6ec84d4ff98226.svg";